// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
interface Args {
  billingPeriodMinutes: string;
  feePerDayUsd: string;
}

export const isValidFee = (args: Args) => {
  const { billingPeriodMinutes, feePerDayUsd } = args;
  const billingPeriodMinutesInput = Number.isNaN(parseFloat(billingPeriodMinutes))
    ? 10
    : parseFloat(billingPeriodMinutes);
  const feePerDayUsdInput = Number.isNaN(parseFloat(feePerDayUsd)) ? 0 : parseFloat(feePerDayUsd);
  const feePerMinuteUsd = feePerDayUsdInput / 24 / 60;
  const feePerBillingUsd = feePerMinuteUsd * billingPeriodMinutesInput;
  const expectedCostPerBillingUsd = 0.08;
  if (feePerBillingUsd < expectedCostPerBillingUsd) {
    // Fee per day too small
    return false;
  }
  return true;
};
